const sectionBlog = 'template--blog'
const sectionArticles = 'articles-item'
const sectionId = document.querySelector('.section-blogs').dataset.sectionId
let blogPage = document.querySelector('.section-blogs .section__content');
let infinityPoint = document.querySelector('#infinity-point');
let limit = +blogPage.dataset.limit;
let count = +blogPage.dataset.count;
let totalPage = Math.ceil(count / limit);

function init() {
    blogPage = document.querySelector('.section-blogs .section__content');
    infinityPoint = document.querySelector('#infinity-point');
    limit = +blogPage.dataset.limit;
    count = +blogPage.dataset.count;
    totalPage = Math.ceil(count / limit);
    //getAll();
    handleClickTab();
    handleMoblieTab();
    handleClickBtnPagination();
    initInfinityObserver();
    //setShowing(count, false

    let place_items = document.querySelectorAll('.place_holder .item')
    let tags = document.querySelectorAll('.card-article-tag .tag-item')

    place_items?.forEach(element=>{
        tags?.forEach(ele=>{
            let value = element.innerHTML.trim();
            let tag = ele.innerHTML.trim();
            if (tag == value) {
                ele.classList.add('checking')
            }
        })
    })

} 

// shopifyReloadSection(init, sectionId)

function handleMoblieTab()
{
    const select_moblie = document.querySelector('.jsSelect');
    select_moblie?.addEventListener('change',async ()=>{
        //console.log("select_moblie", select_moblie.value)
        const url = select_moblie.value;
        const _url = `${url}?section_id=${sectionBlog}&limit=20`
        // console.log("url",url)
        // console.log("_url",_url)
        const label = e.dataset.label;
        await appendData(_url,label)
    })


}
function handleClickTab() {
    //console.log('testing right now')
    const listTab = document.querySelectorAll('.content-header-tab__list-title .tab-title');
    listTab.length && listTab.forEach(tab => tab.addEventListener("click", async (event) => {
        listTab.forEach(item => item.classList.contains('active') ? item.classList.remove('active') : null);
        tab.classList.add('active')

        const url = event.target.dataset.url;
        const countArticle = event.target.dataset.countArticle;
        const _url = `${url}?section_id=${sectionBlog}&limit=20`;
        const label = tab.dataset.label;
        // console.log("url",url)
        // console.log("_url",_url)
        await appendData(_url,label)
        // if (url) {
        //     if (infinityPoint) {
        //         const page = infinityPoint.getAttribute('data-page');
        //         if (+page > 1) {
        //             infinityPoint.setAttribute('data-page', 1)
        //         }
        //     }
        //     await appendData(_url)
        //     //const elmArticle = document.querySelectorAll('.card-article')
        //     // setShowing(elmArticle.length)
        //     // setShowing(countArticle, false)

        // } else {
        //     const paginationHolder = document.querySelector('.content-body .pagination-holder');
        //     if (paginationHolder) {
        //         paginationHolder.remove();
        //     }
        //     if (infinityPoint) {
        //         infinityPoint.setAttribute("data-page", 2);
        //     }
        //     getAll();
        //     //setShowing(count, false)
        // }
    }));
}



async function fetchData(url) {
    try {
        const response = await fetch(url);
        const data = await response.text();
        return data
    } catch (error) {
        return error;
    }
}


async function initInfinityObserver() {
    if (infinityPoint) {
        const observer = new IntersectionObserver(async (entries) => {
            entries.forEach(async (entry) => {
                if (entry.isIntersecting) {
                    try {
                        const page = +entry.target.dataset.page;
                        if (page <= totalPage && page > 1) {
                            getAll(true, page);
                            infinityPoint.setAttribute("data-page", page + 1);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        });
        observer.observe(infinityPoint);
    }
}


async function getAll(check = false, page = 1) {
    const startIndex = (page - 1) * limit;
    let endIndex = startIndex + limit;
    if (endIndex >= count) {
        endIndex = count;
    }
    //setShowing(endIndex)
    try {
        const dataListHandle = blogPage.dataset.listHandle;
        const data = dataListHandle.split(';').slice(0, -1);
        const promiseArr = data.slice(startIndex, endIndex).map(url => getProduct(url));
        const htmlResults = await Promise.all(promiseArr);
        const concatenatedHtml = htmlResults.join('');

        const body = document.querySelector('.section-blogs .content-body .content-body__articles');

        if (check) {
            body.insertAdjacentHTML('beforeend', concatenatedHtml);
        } else {
            body.innerHTML = concatenatedHtml;
        }
    } catch (error) {
        console.error("Error:", error);
    }
}

function getProduct(url) {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok');
                }
            })
            .then(data => {
                const content = data.split('<!-- split -->')[1];
                resolve(content);
            })
            .catch(error => {
                reject(new Error('Network error: ' + error.message));
            });
    });
}

async function appendData(url,label) {
    const body = document.querySelector('.section-blogs .content-body .content-body__articles');
    body.innerHTML = ''
    const paginationHolder = document.querySelector('.section-blogs .content-body .pagination-holder');
    if (paginationHolder) {
        paginationHolder.remove();
    }

    // const data = await fetchData(url);
    // console.log('data', data);
    // const _data1 = data.split('<!-- split -->')[1];
    // const _data2 = data.split('<!-- split -->')[2];
    // const _data3 = data.split('<!-- split -->')[3];
   const data = await fetch(url)
    .then(e => e.text())
    .then(html => {
      const div = document.createElement('div');
      div.innerHTML = html;
    
      let place_items = document.querySelectorAll('.place_holder .item')

      div.querySelectorAll('.card-article').forEach(e=>{
        if ( div.querySelectorAll('.card-article').length == 1) {
            e.classList.remove('first-card');
            e.classList.add('full-card');
        }
        let tags = e.querySelectorAll('.card-article-tag .tag-item')

        place_items.forEach(element=>{
            tags?.forEach(ele=>{
                let value = element.innerHTML.trim();
                let tag = ele.innerHTML.trim();
                if (tag == value) {
                    ele.classList.add('checking')
                }
            })
        })

   
        body.appendChild(e);
      })
      if (div.querySelector('.section-blogs .content-body .pagination-holder')) {
        document.querySelector(".pagination-wrap").innerHTML =   div.querySelector(".pagination-wrap").innerHTML;
      }
    })


    //body.insertAdjacentHTML('beforebegin', _data1);
    //body.insertAdjacentHTML('beforeend', _data2);
    //body.parentNode.insertAdjacentHTML('beforeend', _data3);
    handleClickBtnPagination();
}

function handleClickBtnPagination() {
    const paginationItems = document.querySelectorAll('ul.pagination li:not(:has(a[href="javascript:;"])):not(.ellipsis)');
    paginationItems.forEach(paginateLink => {
        paginateLink.addEventListener("click", async event => {
            const listTab = document.querySelector('.content-header-tab__list-title .tab-title');
            event.preventDefault();
            const href = paginateLink.querySelector('a').getAttribute("href");
            const url = href + `&section_id=${sectionBlog}`;
            listTab.scrollIntoView();
            await appendData(url);
            //updateShowingPagination(url)
        })
    })
}

function getQueryStringValue(url, key) {
    const params = new URLSearchParams(url.split('?')[1]);
    return params.get(key);
}

function updateShowingPagination(url) {
    const limitValue = getQueryStringValue(url, "limit");
    const pageValue = getQueryStringValue(url, "page");
    const elmArticle = document.querySelectorAll('.card-article');
    const countFrom = (pageValue - 1) * limitValue + elmArticle.length
    setShowing(countFrom)
}



// export function shopifyReloadSection(callback, sectionId, isShopifySectionReload = true) {
//     if (callback) {
//         callback()
//         if (isShopifySectionReload) {
//             /** shopify:section:load */
//             document.addEventListener("shopify:section:load", (event) => {
//                 if (event.detail.sectionId === sectionId) {
//                     callback()
//                 }
//             });
//         }
//     }
// }

// function setShowing(number, isFrom = true) {
//     if (isFrom) {
//         const showingFrom = document.querySelector('.jsUpdateShowingFrom')
//         showingFrom.textContent = number
//     } else {
//         const showingTo = document.querySelector('.jsUpdateShowingTo')
//         showingTo.textContent = number
//     }
// }

init();

